import React, { lazy } from 'react';
import { Link } from 'react-router-dom';
const FeaturedItems = () => {
  const featuredDishes = [{
    id: 1,
    name: 'Kare-Kare',
    description: 'A Filipino stew with a thick peanut sauce, oxtail, and vegetables.',
    price: 299.0,
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/wfcm5TzpGnGaMfZVrn6ZSk/karekare.jpg',
    popular: true
  }, {
    id: 2,
    name: 'Bulalo',
    description: 'A light-colored soup made by cooking beef shanks and bone marrow with corn, potatoes, and vegetables.',
    price: 320.0,
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/xygfVbdEWgWP3jK3z6Uqid/Bulalo.jpg',
    popular: true
  }, {
    id: 3,
    name: 'Sinigang',
    description: 'A sour soup with pork, vegetables, and tamarind.',
    price: 280.0,
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/uxM8pHhbUXC3pGWHzJs6Tf/sinigang.jpg',
    popular: false
  }];
  return <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8" data-id="element-76">
      {featuredDishes.map(dish => <div key={dish.id} className="bg-amber-50 rounded-lg overflow-hidden shadow-md transition-transform hover:scale-105" data-id="element-77">
          <div className="relative" data-id="element-78">
            <img src={dish.image} alt={dish.name} className="w-full h-48 object-cover" loading="lazy" data-id="element-79" />
            {dish.popular && <div className="absolute top-0 right-0 bg-amber-800 text-white px-3 py-1 text-sm font-semibold" data-id="element-80">
                Popular
              </div>}
          </div>
          <div className="p-6" data-id="element-81">
            <h3 className="text-xl font-semibold mb-2 text-amber-900" data-id="element-82">
              {dish.name}
            </h3>
            <p className="text-amber-800 mb-4 line-clamp-2" data-id="element-83">
              {dish.description}
            </p>
            <div className="flex justify-between items-center" data-id="element-84">
              <span className="text-lg font-bold text-amber-900" data-id="element-85">
                ₱{dish.price.toFixed(2)}
              </span>
              <Link to={`/menu/${dish.id}`} className="px-4 py-2 bg-amber-800 text-white rounded hover:bg-amber-900 transition" data-id="element-86">
                Order Now
              </Link>
            </div>
          </div>
        </div>)}
    </div>;
};
export default FeaturedItems;